(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swishin-complete-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gridOf = (btn) => {
      const viewport = btn.closest('.sw-ctl__viewport');
      return viewport ? viewport.querySelector('[data-sw-recommendations-grid]') : null;
    };

    const step = (grid) => {
      const card = grid.firstElementChild;
      return card ? card.getBoundingClientRect().width + 12 : grid.clientWidth * 0.8;
    };

    const sync = (grid) => {
      const viewport = grid.closest('.sw-ctl__viewport');
      if (!viewport) return;
      const prev = viewport.querySelector('[data-sw-ctl-prev]');
      const next = viewport.querySelector('[data-sw-ctl-next]');
      if (!prev || !next) return;

      const overflows = grid.scrollWidth - grid.clientWidth > 4;
      prev.hidden = !overflows;
      next.hidden = !overflows;
      if (!overflows) return;
      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
    };

    const syncAll = () => {
      document.querySelectorAll('.sw-ctl__viewport [data-sw-recommendations-grid]').forEach(sync);
    };

    // Delegated so the arrows keep working after the recommendations fetch
    // replaces the grid's contents, and regardless of script/section order.
    document.addEventListener('click', (event) => {
      const btn = event.target instanceof Element ? event.target.closest('[data-sw-ctl-prev], [data-sw-ctl-next]') : null;
      if (!btn) return;

      const grid = gridOf(btn);
      if (!grid) return;

      event.preventDefault();
      const dir = btn.hasAttribute('data-sw-ctl-prev') ? -1 : 1;
      grid.scrollBy({ left: dir * step(grid), behavior: 'smooth' });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const grid = event.target instanceof Element ? event.target.closest('[data-sw-recommendations-grid]') : null;
        if (grid) sync(grid);
      },
      true
    );

    window.addEventListener('resize', syncAll);
    document.addEventListener('sw:cards-rendered', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
    document.addEventListener('DOMContentLoaded', syncAll);
    syncAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swishin-ugc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const step = (grid) => {
      const tile = grid.firstElementChild;
      return tile ? tile.getBoundingClientRect().width + 14 : grid.clientWidth * 0.8;
    };

    const sync = (grid) => {
      const viewport = grid.closest('.sw-ugc__viewport');
      if (!viewport) return;

      const prev = viewport.querySelector('[data-sw-ugc-prev]');
      const next = viewport.querySelector('[data-sw-ugc-next]');
      if (!prev || !next) return;

      const overflows = grid.scrollWidth - grid.clientWidth > 4;
      prev.hidden = !overflows;
      next.hidden = !overflows;
      if (!overflows) return;

      prev.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
    };

    const syncAll = () => document.querySelectorAll('.sw-ugc__viewport .sw-ugc__grid').forEach(sync);

    // Delegated, because the Instagram feed swaps the whole row of tiles in
    // after first paint.
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-sw-ugc-prev], [data-sw-ugc-next]');
      if (!button) return;

      const grid = button.closest('.sw-ugc__viewport')?.querySelector('.sw-ugc__grid');
      if (!grid) return;

      const direction = button.hasAttribute('data-sw-ugc-prev') ? -1 : 1;
      grid.scrollBy({ left: direction * step(grid), behavior: 'smooth' });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const grid = event.target instanceof Element ? event.target.closest('.sw-ugc__grid') : null;
        if (grid) sync(grid);
      },
      true
    );

    window.addEventListener('resize', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
    document.addEventListener('DOMContentLoaded', syncAll);
    syncAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
